/* eslint-disable import/no-cycle */
import {action, decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {Yield} from '../models/yield';

export class YieldStore extends EntityStore {
  yields = [];

  constructor(rootStore) {
    super(rootStore, 'yields', Api.yields, Yield);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.operationStore,
        modelId: 'operationId',
      },
      {
        store: this.rootStore.yieldTypeStore,
        modelId: 'yieldTypeId',
      },
      {
        store: this.rootStore.userStore,
        modelId: 'createdBy',
      },
      {
        store: this.rootStore.unitOfMeasurementStore,
        modelId: 'unitOfMeasureId',
      },
      {
        store: this.rootStore.batchStore,
        modelId: 'batchId',
      },
    ];
  }

  /**
   *
   * @param operationId{number|number[]}
   * @param paramOptions{object}
   * @return {*}
   */
  loadByOperation(operationId, paramOptions) {
    return this.loadAllWithDependencies({params: {operationId}, ...paramOptions});
  }

  getByOperation(operationId) {
    return this.yields.filter((y) => y.operationId === operationId);
  }

  getByOperations(operationIds) {
    return this.yields.filter((y) => operationIds.find((operationId) => y.operationId === operationId));
  }

  getFilteredByExistingBatch() {
    return this.yields.filter((y) => y.batchId);
  }

  getByIds(ids) {
    return super.getByIds(ids);
  }
}

decorate(YieldStore, {
  yields: observable,
  loadByOperation: action,
});
